import { render, staticRenderFns } from "./ModalTagSelect.vue?vue&type=template&id=4dc4951b&scoped=true"
import script from "./ModalTagSelect.vue?vue&type=script&lang=js"
export * from "./ModalTagSelect.vue?vue&type=script&lang=js"
import style0 from "./ModalTagSelect.vue?vue&type=style&index=0&id=4dc4951b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dc4951b",
  null
  
)

export default component.exports